import { makeStyles } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { getConfig } from '../../../util/configUtil';
import { useEffect } from 'react';
import useOpenState from '../../../hooks/useOpenState';
import ContextViewer from '../../patient/patientContext/contextViewer';

export const useStyles = makeStyles((theme) => ({
    iframe: {
        width: '100vw',
        height: '90vh',
        border: 'none',
        overflowX: 'hidden',
        overflowY: 'hidden',
    },
}));

export const EWTDashboard = ({ isAdminMode = false }) => {
    const classes = useStyles();

    // Config
    const insightDashboard = getConfig('modules.insightDashboard', {});
    const path = isAdminMode ? '/boards/ewaittime' : '/view/ewaittime';
    const token = window.keycloak ? window.keycloak.token : window.auth.token;
    const refreshToken = window.keycloak ? window.keycloak.refreshToken : window.auth.refreshToken;
    const iFrameSource = `${insightDashboard?.url ?? ''}${path}?token=${encodeURIComponent(token)}&refreshToken=${encodeURIComponent(refreshToken)}`;

    const [isContextViewerOpen, openContextViewer, closeContextViewer] = useOpenState(false, true);

    const [init, setInit] = useState(false);
    const [contextViewerData, setContextViewerData] = useState({});

    const handleSetContextViewerData = useCallback(
        (data) => {
            setContextViewerData(data);
        },
        [setContextViewerData],
    );

    useEffect(() => {
        if (init) {
            const token = window.keycloak ? window.keycloak.token : window.auth.token;
            const refreshToken = window.keycloak ? window.keycloak.refreshToken : window.auth.refreshToken;
            handleSendMessage({ type: 'SET_TOKEN', token, refreshToken });
            handleSendMessage({ type: 'OPEN_CONTEXT_VIEWER_DATA', openContext: openContextViewer });
            handleSendMessage({ type: 'SET_CONTEXT_VIEWER_DATA', setContextData: handleSetContextViewerData });
        }
    }, [init, handleSetContextViewerData]);

    useEffect(() => {
        if (init) {
            handleSendMessage({ type: 'SET_THEME', theme: window._getTheme() });
        }
    }, [init, window._theme]);

    const handleSendMessage = (body) => {
        const wn = document.getElementById('ewt-dashboard');
        if (!wn) return;
        const originUrl = new URL(wn.src).origin;

        setTimeout(() => {
            wn.contentWindow.postMessage(body, originUrl);
        }, 500);
    };

    return (
        <>
            <iframe
                id="ewt-dashboard"
                className={classes.iframe}
                src={iFrameSource}
                title="Treatments Board"
                onLoad={() => setInit(true)}
                onError={(e) => console.error('iFrame Error', e)}
            />

            {isContextViewerOpen && (
                <ContextViewer
                    currentPatient={contextViewerData?.selectedPatient}
                    contextOpen={isContextViewerOpen}
                    closeContext={closeContextViewer}
                    idElement="current"
                    arrivalMode={contextViewerData?.ambulanceCodes}
                    // isSameName={isMultiSameNamePt}
                />
            )}
        </>
    );
};
